import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiErrorHandler } from '../../../errors/api-error-handler';
import { BlackFridayInitialStateType, BlackFridayType } from '../../../models/education/blcak-friday-model';
import BlackFridayService from '../../../services/education/black-friday.service';

const initialState: BlackFridayInitialStateType = {
    BlackFridayData: [],
    BlackFridayLoading: true,
    BlackFridayError: undefined
};

type queryparamsType = {
    path: string
    pageNumber: number
}

export const retrieveBlackFriday = createAsyncThunk('BlackFriday/retrieve',
    async (queryparams:queryparamsType , { rejectWithValue }) => {
        try {

            const response = await BlackFridayService.getBlackFriday(queryparams.path, queryparams.pageNumber)
            return [response.data]

        } catch (error: any) {
            if (!error.response) {
                throw error
            }
            return rejectWithValue(error.response.status)
        }
    }
)

const BlackFridaySlice = createSlice({
    name: 'BlackFriday',
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(retrieveBlackFriday.pending, (state) => {
                state.BlackFridayLoading = true;
            })
            .addCase(retrieveBlackFriday.fulfilled, (state, action) => {
                if (action.payload) {
                    state.BlackFridayLoading = false;
                    state.BlackFridayData = action.payload as BlackFridayType[];
                }
            })
            .addCase(retrieveBlackFriday.rejected, (state, { payload }) => {
                state.BlackFridayLoading = false;
                state.BlackFridayError = apiErrorHandler(Number(payload))
            })
    }
})

export const selectAllEntities = (state: { entities: any; }) => state.entities;
export default BlackFridaySlice.reducer;
